var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgC2PIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4285.438,
    height: 629.048,
    viewBox: "0 0 4285.438 629.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8247",
    "data-name": "Group 8247",
    transform: "translate(-2713.416 -4939.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8184",
    "data-name": "Group 8184",
    transform: "translate(6005.291 4939.288)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7034",
    "data-name": "Path 7034",
    d: "M496.253,306.546A305.113,305.113,0,0,1,613.6,66.21C488.06-33.17,307.176-19.177,198.409,98.329s-108.767,298.93,0,416.436S488.06,646.262,613.6,546.882A305.112,305.112,0,0,1,496.253,306.546Z",
    transform: "translate(-116.834 0.445)",
    fill: "#ed2026"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7035",
    "data-name": "Path 7035",
    d: "M250.372,6.355c57.971-27.93,117.351,107.494,117.351,240.336S306.465,520.12,250.372,487.027C200.145,456.985,131.612,379.3,133.02,246.691S211.88,24.662,250.372,6.355Z",
    transform: "translate(246.398 59.832)",
    fill: "#f26a21"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7037",
    "data-name": "Path 7037",
    d: "M327.874,0A305.112,305.112,0,0,0,138,66.186a305.112,305.112,0,0,1,114.816,204.6A305.111,305.111,0,0,1,188.461,496.4,301.794,301.794,0,0,1,138,546.858,306.522,306.522,0,1,0,327.874,0Z",
    transform: "translate(358.77 0)",
    fill: "#f99f1d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_21316",
    "data-name": "Path 21316",
    d: "M221.4,92.255H124.5v17.107c75.477,2.509,98.035,37.593,106.408,78.567l44.5,439.655h146.74L734.74,92.255H588.359l-187.844,321.7-31.856-321.7Z",
    transform: "translate(3937.177 4888.414)",
    fill: "#1434cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21317",
    "data-name": "Path 21317",
    d: "M1037.247,92.255H1180.6L1004.314,627.328H863.532Z",
    transform: "translate(3734.629 4888.414)",
    fill: "#1434cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21318",
    "data-name": "Path 21318",
    d: "M2118.08,106.821l-275.1,525.24h154.139l40.2-79.953H2216.5l5.9,79.953h140.768l-39.289-525.24H2118Zm74.943,135.063,16.631,222.03H2080.938Z",
    transform: "translate(3466.223 4883.934)",
    fill: "#1434cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21319",
    "data-name": "Path 21319",
    d: "M1320.328,225.132c21.418-84.2,91.244-142.589,210.678-142.589A333.228,333.228,0,0,1,1725.631,152.4l-84.479,88.455A240.66,240.66,0,0,0,1542.023,192c-48.74,0-70.693,17.977-75.191,46.61-8.75,58.08,198.5,93.472,191.984,228.79-14.322,102.094-102.1,177.958-205.521,177.674a399.136,399.136,0,0,1-240.227-64.329L1286.525,478.3A257.641,257.641,0,0,0,1427.3,533.056c46.264-2,82.209-19.615,79.441-50.5-5.119-70.73-223.594-103.049-184.967-257.114Z",
    transform: "translate(3638.635 4891.362)",
    fill: "#1434cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21323",
    "data-name": "Path 21323",
    d: "M690.339,12.131a26.368,26.368,0,0,0-48.966,13.726,26.7,26.7,0,0,0,8.53,19.514L848.849,287.018,652.116,524.053H567.081l186-216.753a.546.546,0,0,1,.309-.461h0a27.672,27.672,0,0,0,7.449-18.9,26.7,26.7,0,0,0-7.449-18.9h0a.545.545,0,0,0-.309-.461L530.909,12.49h0A26.473,26.473,0,0,0,508.149-.417H352.055a26.418,26.418,0,0,0-26.409,26.428v.051A21.25,21.25,0,0,0,328.832,38.3l206.7,250.968L359.3,500.7a56.859,56.859,0,0,1-42.954,22.688H105.226a51.761,51.761,0,0,1-52.306-51.21c0-.346,0-.687,0-1.033V104.119a54.839,54.839,0,0,1,52.921-52.447H237.478a25.044,25.044,0,0,0,26.393-23.606q.064-1.18.017-2.362A25.639,25.639,0,0,0,239.58-1.212q-1.05-.055-2.1-.024L104.609-.622C46.81-.537,0,46.194,0,103.811V471.3A107.723,107.723,0,0,0,104.609,576.192H315.73a104.254,104.254,0,0,0,29.081-4.1c1.285-.3,2.518-.765,3.648-1.123A115.728,115.728,0,0,0,398.4,538.036l198.122-231.4a27.6,27.6,0,0,0,0-37.645h0a.546.546,0,0,0-.31-.461L408.779,51.825h86.577L691.264,287.94,485.08,537.168a.953.953,0,0,0,.305.613,26.553,26.553,0,0,0,23.379,38.773H664.752a26.481,26.481,0,0,0,22.764-12.909h0L909.527,307.556a.545.545,0,0,1,.31-.461h0a27.6,27.6,0,0,0,0-37.645Z",
    transform: "translate(2713.416 4969.191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21324",
    "data-name": "Path 21324",
    d: "M19.465,618.53a25.65,25.65,0,0,1-25.69-25.609V19.384a25.69,25.69,0,0,1,51.38,0V592.921A25.65,25.65,0,0,1,19.465,618.53Z",
    transform: "translate(3850.259 4949.807)",
    fill: "#c6c6c6"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC2PIcon);
export default __webpack_public_path__ + "static/media/c2p_icon.4a6eae7647eccded88f833254a742663.svg";
export { ForwardRef as ReactComponent };